export default "/_next/static/images/filter2-21473b99a8bcf96fbc716e5706b32c87.gif";